import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import IndendorsPage from './pages/IndendorsPage';
import UdendorsPage from './pages/UdendorsPage';
import MalerNorresundbyPage from './pages/MalerNorresundbyPage';
import MalerBronderslevPage from './pages/MalerBronderslevPage';
import MalerStovringPage from './pages/MalerStovringPage';
import ProjectsPage from './pages/ProjectsPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-[#F8FAFC] text-gray-800 antialiased selection:bg-[#65237e] selection:text-white">
      <ScrollToTop />
      <Header />
      
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/om-os" element={<AboutPage />} />
          <Route path="/ydelser" element={<ServicesPage />} />
          <Route path="/indendors-projekter" element={<IndendorsPage />} />
          <Route path="/udendors-projekter" element={<UdendorsPage />} />
          <Route path="/maler-norresundby" element={<MalerNorresundbyPage />} />
          <Route path="/maler-bronderslev" element={<MalerBronderslevPage />} />
          <Route path="/maler-stovring" element={<MalerStovringPage />} />
          <Route path="/projekter" element={<ProjectsPage />} />
          <Route path="/galleri" element={<ProjectsPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}
